/** 这里是 Mutations */

export default {
    /**这个函数用于修改 state 里面的值是公用的*/
    amendState(state, newValObj) {
        /** 
         * Mutation  只能同步执行
         * newValObj 需要改变一个值的时候传一个对象进来
         *           需要改边多个值得时候传一个数组里面包含多个对象
         */
        const assign = val => {
            for (let key in val) {
                state[key] = val[key]
            }
        };
        Array.isArray(newValObj) ? newValObj.forEach(val => { assign(val) }) : assign(newValObj)
        // console.log('amendState', state)
    }
}


// WEBPACK FOOTER //
// ./src/store/mutations.js